import AddTeamMate from './AddTeamMate';
export default AddTeamMate;
